import { render } from "./TradeLineItemsForm.vue?vue&type=template&id=4c721970&scoped=true"
import script from "./TradeLineItemsForm.vue?vue&type=script&lang=js"
export * from "./TradeLineItemsForm.vue?vue&type=script&lang=js"

import "./TradeLineItemsForm.vue?vue&type=style&index=0&id=4c721970&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c721970"]])

export default __exports__